(() => {
  if (!("HTMLDialogElement" in window)) return;

  let lastTrigger = null;

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest(
      '[data-newsletter-modal-open], a[href="#newsletter"]',
    );
    if (!trigger) return;

    const dialog = document.querySelector("[data-newsletter-modal-dialog]");
    if (!(dialog instanceof HTMLDialogElement) || typeof dialog.showModal !== "function") return;
    if (dialog.open) return;

    event.preventDefault();
    lastTrigger = trigger;
    dialog.showModal();
  });

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    const dialog = event.target.closest("[data-newsletter-modal-dialog]");
    if (!(dialog instanceof HTMLDialogElement)) return;

    if (event.target.closest("[data-newsletter-modal-close]")) {
      dialog.close();
      return;
    }

    if (event.target === dialog) dialog.close();
  });

  document.addEventListener("close", (event) => {
    if (!(event.target instanceof HTMLDialogElement) ||
        !event.target.matches("[data-newsletter-modal-dialog]")) return;
    if (lastTrigger instanceof HTMLElement && lastTrigger.isConnected) {
      lastTrigger.focus();
    }
  }, true);
})();